module.exports = __webpack_public_path__ + "static/media/service.f4bd3530.jpg";